// React Imports
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// I18n
import { Translate, I18n } from 'react-redux-i18n';

// Import Spectrum Components
import Dialog from '@react/react-spectrum/Dialog';

// Actions
import { dismissError } from '../../actions/errorActions';

/**
 * Component for displaying the Error Dialog.
 *
 * This component displays an error message and depending on the type of error (fatal or non),
 * will direct the user to contact the helpdesk.
 *
 * @component
 * @example
 *
 * return (
 *   <ErrorDialog />
 * )
 */
class ErrorDialog extends Component {
    // Dismisses the error, or directs the user to the helpdesk.
    dismissError = () => {
      const { dismissErrorAction, error } = this.props;

      if (!error.fatal) {
        dismissErrorAction();
      } else {
        window.open(I18n.t('global.footer.help_link'));
      }
    }

    contactHelpdesk = () => {
      window.open(I18n.t('global.footer.help_link'));
    }

    renderConfirmButton = () => {
      const { error } = this.props;
      if (!error.fatal) {
        return I18n.t('workflow.error_page.ok');
      }
      return I18n.t('workflow.error_page.contact_helpdesk');
    }

    renderCancelButton = () => {
      const { error } = this.props;
      if (!error.fatal) {
        return I18n.t('workflow.error_page.contact_helpdesk');
      }
      return null;
    }

    renderDialog = () => {
      const { error } = this.props;

      if (error) {
        return (
          <div className="error-dialog">
            <Dialog
              variant="error"
              cancelLabel={this.renderCancelButton()}
              autoFocusButton="confirm"
              confirmLabel={this.renderConfirmButton()}
              onConfirm={this.dismissError}
              onCancel={this.contactHelpdesk}
              disableEscKey
              open
              role="dialog"
              title={I18n.t('workflow.error_page.problem_header')}
              trapFocus
            >
              <Translate value={error.messagePath} />
            </Dialog>
            <div className="spectrum-Underlay is-open" />
          </div>
        );
      }
      return null;
    };

    render() { return this.renderDialog(); }
}
ErrorDialog.propTypes = {
/* error {Object} The error object in the redux store. Has the path to the localized error message,
 * and whether the error is fatal.
 */
  error: PropTypes.shape({
    messagePath: PropTypes.string,
    fatal: PropTypes.bool,
  }),
  /* dismissErrorAction {Function} The action to clear the error from the redux store, provided by
   * mapDispatchToProps.
   */
  dismissErrorAction: PropTypes.func.isRequired,
};
ErrorDialog.defaultProps = {
  error: null,
};

const mapStateToProps = (state) => ({
  error: state.errors,
  locale: state.i18n.locale,
});

const mapDispatchToProps = {
  dismissErrorAction: dismissError,
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorDialog);
